function pad (value) {
  return value < 10 ? '0' + value : '' + value
}

function normalizeDateValue (value) {
  if (!value) {
    return null
  }
  if (value instanceof Date) {
    return value
  }
  if (typeof value === 'number') {
    return new Date(value)
  }
  if (typeof value === 'string') {
    let normalized = value.trim()
    if (!normalized) {
      return null
    }
    normalized = normalized.replace('T', ' ')
    normalized = normalized.replace(/([+-]\d{2})(\d{2})$/, '$1:$2')
    normalized = normalized.replace(' ', 'T')
    return new Date(normalized)
  }
  return null
}

export function formatPlatformDate (value) {
  const date = normalizeDateValue(value)
  if (!date || Number.isNaN(date.getTime())) {
    return value || '-'
  }
  return [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate())
  ].join('-') + ' ' + [
    pad(date.getHours()),
    pad(date.getMinutes()),
    pad(date.getSeconds())
  ].join(':')
}



// WEBPACK FOOTER //
// ./src/assets/utils/platformDate.js